module.exports = __webpack_public_path__ + "static/media/waiter.b1566521.svg";